// extracted by mini-css-extract-plugin
export default {"dialogContent":"AiAgentConfigDialogContent_dialogContent__B3SRo","tabs":"AiAgentConfigDialogContent_tabs__nPrep"};